// @flow
// This file will replace the `general.js` once we get rid of the devices font icons

const generalIcons = {
    ACTIONS: 'ACTIONS',
    ADD_DEVICES: 'ADD_DEVICES',
    ARROW_DOWN: 'ARROW_DOWN',
    ARROW_LEFT: 'ARROW_LEFT',
    ARROW_LEFT_SHAFT: 'ARROW_LEFT_SHAFT',
    ARROW_RIGHT: 'ARROW_RIGHT',
    ARROW_RIGHT_DOUBLE: 'ARROW_RIGHT_DOUBLE',
    ARROW_UP: 'ARROW_UP',
    BATTERY_EMPTY: 'BATTERY_EMPTY',
    BATTERY_FULL: 'BATTERY_FULL',
    BATTERY_LOW: 'BATTERY_LOW',
    BATTERY_NORMAL: 'BATTERY_NORMAL',
    BOOST: 'BOOST',
    BORD_GAIS_LOGO: 'BORD_GAIS_LOGO',
    CALL: 'CALL',
    CIRCLE_FILLED: 'CIRCLE_FILLED',
    CIRCLE_OUTLINE: 'CIRCLE_OUTLINE',
    CLOSE: 'CLOSE',
    CLOSE_HEAVY: 'CLOSE_HEAVY',
    COLOR_PALETE: 'COLOR_PALETE',
    COLOR_PICKER: 'COLOR_PICKER',
    COMFORT: 'COMFORT',
    CONNECTED: 'CONNECTED',
    CONTROL_PAGE: 'CONTROL_PAGE',
    COPY: 'COPY',
    CREATE: 'CREATE',
    CREATE_PLUS: 'CREATE_PLUS',
    DASHBOARD: 'DASHBOARD',
    DEMO: 'DEMO',
    DIMMER: 'DIMMER',
    DISCOVER: 'DISCOVER',
    DOG_BARK: 'DOG_BARK',
    DOWNLOAD: 'DOWNLOAD',
    EDIT: 'EDIT',
    EFFICIENCY: 'EFFICIENCY',
    EXCLAMATION: 'EXCLAMATION',
    FROST_PROTECTION: 'FROST_PROTECTION',
    GLASS_BREAK: 'GLASS_BREAK',
    GRAPHS: 'GRAPHS',
    GROUP_CONTROL: 'GROUP_CONTROL',
    HEATING_PAGE: 'HEATING_PAGE',
    HELP: 'HELP',
    HIVE_ICON: 'HIVE_ICON',
    HOLIDAYS: 'HOLIDAYS',
    HOME: 'HOME',
    HOT_WATER: 'HOT_WATER',
    INCORRECT_SOUND: 'INCORRECT_SOUND',
    INFO: 'INFO',
    INSTALL_DEVICE: 'INSTALL_DEVICE',
    LINK: 'LINK',
    LINK_BROKEN: 'LINK_BROKEN',
    LIST_DEVICE_MENU: 'LIST_DEVICE_MENU',
    LOCK_CLOSED: 'LOCK_CLOSED',
    LOGOUT: 'LOGOUT',
    MANAGE_DEVICE: 'MANAGE_DEVICE',
    MENU: 'MENU',
    MICROPHONE_OFF: 'MICROPHONE_OFF',
    MICROPHONE_ON: 'MICROPHONE_ON',
    MIMIC: 'MIMIC',
    MINUS: 'MINUS',
    MONITOR_SENSE: 'MONITOR_SENSE',
    MONITORING_OFF: 'MONITORING_OFF',
    MONITORING_ON: 'MONITORING_ON',
    MOODS: 'MOODS',
    MORE: 'MORE',
    MORE_VERTICAL: 'MORE_VERTICAL',
    MULTI_PROFILE: 'MULTI_PROFILE',
    NOTIFICATIONS: 'NOTIFICATIONS',
    NOTIFICATIONS_OFF: 'NOTIFICATIONS_OFF',
    OVERFLOW: 'OVERFLOW',
    PAUSE: 'PAUSE',
    PAUSE_SIMPLE: 'PAUSE_SIMPLE',
    PLAY: 'PLAY',
    PLAY_SIMPLE: 'PLAY_SIMPLE',
    PLUS: 'PLUS',
    QUESTION: 'QUESTION',
    REASSURANCE: 'REASSURANCE',
    RECIPES: 'RECIPES',
    RESET_RELOAD: 'RESET_RELOAD',
    SCHEDULE: 'SCHEDULE',
    SEARCH: 'SEARCH',
    SETTINGS: 'SETTINGS',
    SHOP: 'SHOP',
    SIGNAL_1_BARS: 'SIGNAL_1_BARS',
    SIGNAL_2_BARS: 'SIGNAL_2_BARS',
    SIGNAL_3_BARS: 'SIGNAL_3_BARS',
    SIGNAL_4_BARS: 'SIGNAL_4_BARS',
    SMOKE_CO: 'SMOKE_CO',
    SMOKE_CO2: 'SMOKE_CO2',
    SOUND_CAM: 'SOUND_CAM',
    SOUND_OFF: 'SOUND_OFF',
    SOUND_ON: 'SOUND_ON',
    STOP: 'STOP',
    STOP_SIMPLE: 'STOP_SIMPLE',
    TICK_ONE: 'TICK_ONE',
    TICK_SIMPLE: 'TICK_SIMPLE',
    TONE: 'TONE',
    TRASH: 'TRASH',
    USER_PROFILE: 'USER_PROFILE',
    WELCOME_HOME: 'WELCOME_HOME',
    WIFI: 'WIFI',
    WIFI_0_BARS: 'WIFI_0_BARS',
    WIFI_1_BARS: 'WIFI_1_BARS',
    WIFI_2_BARS: 'WIFI_2_BARS',
    WIFI_3_BARS: 'WIFI_3_BARS',
    WIFI_OFF: 'WIFI_OFF'
};

export default generalIcons;
export type GeneralIcon = $Keys<typeof generalIcons>;



// WEBPACK FOOTER //
// ./src/core/constants/icons/general-svg.js